// extracted by mini-css-extract-plugin
export var modal = "_k6-0";